import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getOrderIdByShortCode } from "../../services/orderService";
import { Loader } from "../../components/Loader";

export function ShortLinkRedirect() {
    const { code } = useParams<{ code: string }>();
    const navigate = useNavigate();
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
        if (!code) return;

        getOrderIdByShortCode(code)
            .then(({ data }) => navigate(`/completarPedido/${data.id}`, { replace: true }))
            .catch(() => setNotFound(true));
    }, [code, navigate]);

    if (notFound) {
        return (
            <p style={{ textAlign: "center", marginTop: "40px" }}>
                Link inválido ou expirado. Entre em contato com a loja.
            </p>
        );
    }

    return <Loader show={true} />;
}
